import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { SkeletonLabel } from "./SkeletonLabel";
import * as styles from "./SkeletonCard.styles";
export var SkeletonCard = function SkeletonCard(_ref) {
  var className = _ref.className,
    _ref$cropImageForMobi = _ref.cropImageForMobile,
    cropImageForMobile = _ref$cropImageForMobi === void 0 ? true : _ref$cropImageForMobi,
    imageStyle = _ref.imageStyle,
    productIndex = _ref.productIndex;
  return /*#__PURE__*/React.createElement(_StyledSection, {
    className: className,
    "data-testid": "skeleton-card",
    $_css: styles.card
  }, /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css2: [styles.imagePlaceholder, cropImageForMobile && productIndex && (productIndex % 2 === 0 ? styles.mobileImageCropOdd : styles.mobileImageCropEven), imageStyle]
  }), /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css3: styles.copy
  }, /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css4: styles.mainSection
  }, /*#__PURE__*/React.createElement(_StyledSkeletonLabel, {
    labelHeight: "MD",
    $_css5: styles.labelMargin
  }), /*#__PURE__*/React.createElement(_StyledSkeletonLabel2, {
    labelHeight: "MD",
    $_css6: styles.labelMargin
  })), /*#__PURE__*/React.createElement(SkeletonLabel, {
    labelHeight: "MD",
    variant: "short"
  })));
};
var _StyledSection = _styled("section")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv2 = _styled3("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv3 = _styled4("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledSkeletonLabel = _styled5(SkeletonLabel)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledSkeletonLabel2 = /*#__PURE__*/_styled6(SkeletonLabel).withConfig({
  displayName: "SkeletonCard___StyledSkeletonLabel2",
  componentId: "sc-1dgs0yf-0"
})(["", ""], function (p) {
  return p.$_css6;
});